import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthProvider';

class SecuredRoute extends React.Component {
    render() {
        return (
            <Route exact path={this.props.path}>
                {
                    this.context.isLoggedIn ? (
                        this.props.children
                    ) : (
                        <Redirect to="/login" />
                    )
                }
            </Route>
        );
    }
}
SecuredRoute.contextType = AuthContext;
export default SecuredRoute;
